<template lang="pug">
  article.brand-card.default-card
    .combined(data-placeholder v-if="!data")
      .frame
        a.preview
          .clp
        .metas
          .name
            .clp.mw-3 &nbsp;
          .address
            .clp.mw-2 &nbsp;
          .action
            .clp.mw-3 &nbsp;
    .combined(v-else)
      .frame
        nuxt-link.preview(
          :to="link"
          v-click="() => $amplitude.trackBrand(trackProps)")
          img.image(:src="image")

        .metas
          .name {{ name }}
          .address {{ address }}
          nuxt-link.action.el-button.el-button--default(:to="link") View this brand

</template>

<script>

export default {
  name: 'BrandOverviewStamp',

  props: {
    data: {
      type: Object,
      default: null
    },
    trackProps: {
      type: [Object, String],
      default: ''
    }
  },

  computed: {
    image () {
      return this.data.logo_url?.product_url
    },
    name () {
      return this.data.name
    },
    address () {
      return this.data.address
    },
    link () {
      return this.$links.brand({
          id: this.data.id,
          name: this.data.name
        })
    }
  }
}
</script>

<style lang="scss" scoped>
article.brand-card {
  $oos: #999;

  .combined {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    > * {
      min-height: 0;
    }
    .frame {
      flex: 1;
    }
  }
  .frame {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .preview {
    transition: filter .2s ease-in-out;

    .image {
      width: 130px;
      object-fit: contain;
      aspect-ratio: 1 / 1;
      display: block;
      background: white;
      padding: 8px;
    }

    .clp {
      width: 130px;
      aspect-ratio: 1 / 1;
    }
  }

  .metas {
    display: flex;
    flex-direction: column;
    padding: 12px 0;
    gap: 12px;
    > * {
      min-height: 0;
    }
    .name {
      font-size: 14px;
      font-weight: $--font-weight-bold;
      a {
        overflow: hidden;
      }
    }
    .action {
      max-width: 130px;
      padding: 10px;
    }
  }
}
</style>
